import { Util } from './../util';
var EmailValidators = (function () {
    function EmailValidators() {
    }
    EmailValidators.simple = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        var pattern = '^.+@.+\\..+$';
        if (new RegExp(pattern).test(control.value)) {
            return undefined;
        }
        return { 'simpleEmailRule': true };
    };
    ;
    // https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
    EmailValidators.normal = function (control) {
        if (Util.isNotPresent(control))
            return undefined;
        // tslint:disable-next-line:max-line-length
        var pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (pattern.test(control.value)) {
            return undefined;
        }
        return { 'normalEmailRule': true };
    };
    ;
    return EmailValidators;
}());
export { EmailValidators };
//# sourceMappingURL=email-validators.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-validators/src/email/email-validators.js
// module id = null
// module chunks = 